const sidebarData: any = [
  {
    label: "Menu",
    isTitle: true,
  },
  {
    id: "dashboard",
    label: "Dashboard",
    link: "/#",
    icon: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM15.8329 7.33748C16.0697 7.17128 16.3916 7.19926 16.5962 7.40381C16.8002 7.60784 16.8267 7.92955 16.6587 8.16418C14.479 11.2095 13.2796 12.8417 13.0607 13.0607C12.4749 13.6464 11.5251 13.6464 10.9393 13.0607C10.3536 12.4749 10.3536 11.5251 10.9393 10.9393C11.3126 10.5661 12.9438 9.36549 15.8329 7.33748ZM17.5 11C18.0523 11 18.5 11.4477 18.5 12C18.5 12.5523 18.0523 13 17.5 13C16.9477 13 16.5 12.5523 16.5 12C16.5 11.4477 16.9477 11 17.5 11ZM6.5 11C7.05228 11 7.5 11.4477 7.5 12C7.5 12.5523 7.05228 13 6.5 13C5.94772 13 5.5 12.5523 5.5 12C5.5 11.4477 5.94772 11 6.5 11ZM8.81802 7.40381C9.20854 7.79433 9.20854 8.4275 8.81802 8.81802C8.4275 9.20854 7.79433 9.20854 7.40381 8.81802C7.01328 8.4275 7.01328 7.79433 7.40381 7.40381C7.79433 7.01328 8.4275 7.01328 8.81802 7.40381ZM12 5.5C12.5523 5.5 13 5.94772 13 6.5C13 7.05228 12.5523 7.5 12 7.5C11.4477 7.5 11 7.05228 11 6.5C11 5.94772 11.4477 5.5 12 5.5Z",
    subItems: [
      {
        id: "default",
        label: "Default",
        link: "/index",
        parentId: "dashboard",
      },
      {
        id: "project",
        label: "Projects",
        link: "/project-dashboard",
        parentId: "dashboard",
      },
      {
        id: "ecommerce",
        label: "ECommerce",
        link: "/ecommerce-dashboard",
        parentId: "dashboard",
      },
    ],
  },
  {
    id: "app",
    label: "Apps",
    link: "/#",
    icon: "M7.5 11.5C5.01472 11.5 3 9.48528 3 7C3 4.51472 5.01472 2.5 7.5 2.5C9.98528 2.5 12 4.51472 12 7C12 9.48528 9.98528 11.5 7.5 11.5ZM7.5 21.5C5.01472 21.5 3 19.4853 3 17C3 14.5147 5.01472 12.5 7.5 12.5C9.98528 12.5 12 14.5147 12 17C12 19.4853 9.98528 21.5 7.5 21.5ZM17.5 11.5C15.0147 11.5 13 9.48528 13 7C13 4.51472 15.0147 2.5 17.5 2.5C19.9853 2.5 22 4.51472 22 7C22 9.48528 19.9853 11.5 17.5 11.5ZM17.5 21.5C15.0147 21.5 13 19.4853 13 17C13 14.5147 15.0147 12.5 17.5 12.5C19.9853 12.5 22 14.5147 22 17C22 19.4853 19.9853 21.5 17.5 21.5ZM7.5 9.5C8.88071 9.5 10 8.38071 10 7C10 5.61929 8.88071 4.5 7.5 4.5C6.11929 4.5 5 5.61929 5 7C5 8.38071 6.11929 9.5 7.5 9.5ZM7.5 19.5C8.88071 19.5 10 18.3807 10 17C10 15.6193 8.88071 14.5 7.5 14.5C6.11929 14.5 5 15.6193 5 17C5 18.3807 6.11929 19.5 7.5 19.5ZM17.5 9.5C18.8807 9.5 20 8.38071 20 7C20 5.61929 18.8807 4.5 17.5 4.5C16.1193 4.5 15 5.61929 15 7C15 8.38071 16.1193 9.5 17.5 9.5ZM17.5 19.5C18.8807 19.5 20 18.3807 20 17C20 15.6193 18.8807 14.5 17.5 14.5C16.1193 14.5 15 15.6193 15 17C15 18.3807 16.1193 19.5 17.5 19.5Z",
    subItems: [
      {
        id: "email",
        label: "Email",
        link: "/email",
        parentId: "app",
      },
      {
        id: "chat",
        label: "Chat",
        link: "/chat",
        parentId: "app",
      },
      {
        id: "contact",
        label: "Contact",
        link: "/contact",
        parentId: "app",
      },
      {
        id: "invoice",
        label: "Invoice",
        link: "/invoice",
        parentId: "app",
      },
      {
        id: "calendar",
        label: "Calendar",
        link: "/calendar",
        parentId: "app",
      },
    ],
  },
  {
    label: "UI Kit",
    isTitle: true,
  },
  {
    id: "component",
    label: "Components",
    link: "/#",
    icon: "M12 1L21.5 6.5V17.5L12 23L2.5 17.5V6.5L12 1ZM5.49388 7.0777L12.0001 10.8444L18.5062 7.07774L12 3.311L5.49388 7.0777ZM4.5 8.81329V16.3469L11.0001 20.1101V12.5765L4.5 8.81329ZM13.0001 20.11L19.5 16.3469V8.81337L13.0001 12.5765V20.11Z",
    subItems: [
      {
        id: "tabs",
        label: "Tabs",
        link: "/ui-tabs",
        parentId: "component",
      },
      {
        id: "accordions",
        label: "Accordions",
        link: "/ui-accordions",
        parentId: "component",
      },
      {
        id: "modals",
        label: "Modals",
        link: "/ui-modals",
        parentId: "component",
      },
      {
        id: "clipboard",
        label: "Clipboard",
        link: "/ui-clipboard",
        parentId: "component",
      },
      {
        id: "notification",
        label: "Notification",
        link: "/ui-notification",
        parentId: "component",
      },
      {
        id: "carousel",
        label: "Carousel",
        link: "/ui-carousel",
        parentId: "component",
      },
      {
        id: "pricing",
        label: "Pricing",
        link: "/ui-pricing",
        parentId: "component",
      },
      {
        id: "lightbox",
        label: "Lightbox",
        link: "/ui-lightbox",
        parentId: "component",
      },
      {
        id: "countdown",
        label: "Countdown",
        link: "/ui-countdown",
        parentId: "component",
      },
      {
        id: "counter",
        label: "Counter",
        link: "/ui-counter",
        parentId: "component",
      },
      {
        id: "flatpickr",
        label: "Flatpickr",
        link: "/ui-flatpickr",
        parentId: "component",
      }
    ],
  },
  {
    id: "element",
    label: "UI Elements",
    link: "/#",
    icon: "M13 9H21L11 24V15H4L13 0V9ZM11 11V7.22063L7.53238 13H13V17.3944L17.263 11H11Z",
    subItems: [
      {
        id: "alerts",
        label: "Alerts",
        link: "/ui-alerts",
        parentId: "element",
      },
      {
        id: "buttons",
        label: "Buttons",
        link: "/ui-buttons",
        parentId: "element",
      },
      {
        id: "buttons-group",
        label: "Buttons Group",
        link: "/ui-buttons-group",
        parentId: "element",
      },
      {
        id: "badge",
        label: "Badge",
        link: "/ui-badge",
        parentId: "element",
      },
      {
        id: "breadcrumb",
        label: "Breadcrumb",
        link: "/ui-breadcrumb",
        parentId: "element",
      },
      {
        id: "videos",
        label: "Videos",
        link: "/ui-videos",
        parentId: "element",
      },
      {
        id: "images",
        label: "Images",
        link: "/ui-images",
        parentId: "element",
      },
      {
        id: "dropdowns",
        label: "Dropdowns",
        link: "/ui-dropdowns",
        parentId: "element",
      },
      {
        id: "typography",
        label: "Typography",
        link: "/ui-typography",
        parentId: "element",
      },
      {
        id: "avatar",
        label: "Avatar",
        link: "/ui-avatar",
        parentId: "element",
      },
      {
        id: "tooltips",
        label: "Tooltips",
        link: "/ui-tooltips",
        parentId: "element",
      },
      {
        id: "loader",
        label: "Loader",
        link: "/ui-loader",
        parentId: "element",
      },
      {
        id: "pagination",
        label: "Pagination",
        link: "/ui-pagination",
        parentId: "element",
      },
      {
        id: "progress-bar",
        label: "Progress Bar",
        link: "/ui-progress-bar",
        parentId: "element",
      },
    ],
  },
  {
    id: "chart",
    label: "Charts",
    link: "/chart",
    icon: "M9 2.4578V4.58152C6.06817 5.76829 4 8.64262 4 12C4 16.4183 7.58172 20 12 20C15.3574 20 18.2317 17.9318 19.4185 15H21.5422C20.2679 19.0571 16.4776 22 12 22C6.47715 22 2 17.5228 2 12C2 7.52236 4.94289 3.73207 9 2.4578ZM12 2C17.5228 2 22 6.47715 22 12C22 12.3375 21.9833 12.6711 21.9506 13H11V2.04938C11.3289 2.01672 11.6625 2 12 2ZM13 4.06189V11H19.9381C19.4869 7.38128 16.6187 4.51314 13 4.06189Z",
  },
  {
    id: "icons",
    label: "Font Icons",
    link: "/icons",
    icon: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C13.4702 20 14.8478 19.6034 16.0316 18.9114L15.0237 17.1835C14.1359 17.7026 13.1027 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12V13C18 13.5523 17.5523 14 17 14C16.4477 14 16 13.5523 16 13V9H14.6458C13.9407 8.37764 13.0144 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C13.0465 16 13.9991 15.5982 14.7119 14.9404C15.2622 15.5886 16.0831 16 17 16C18.6569 16 20 14.6569 20 13V12ZM12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z",
  },
  {
    label: "Table & Forms",
    isTitle: true,
  },
  {
    id: "form",
    label: "Forms",
    link: "/#",
    icon: "M21 8V20.9932C21 21.5501 20.5552 22 20.0066 22H3.9934C3.44495 22 3 21.556 3 21.0082V2.9918C3 2.45531 3.4487 2 4.00221 2H14.9968L21 8ZM19 9H14V4H5V20H19V9ZM8 7H11V9H8V7ZM8 11H16V13H8V11ZM8 15H16V17H8V15Z",
    subItems: [
      {
        id: "forms-basic",
        label: "Basic",
        link: "/forms-basic",
        parentId: "form",
      },
      {
        id: "input-group",
        label: "Input Group",
        link: "/forms-input-group",
        parentId: "form",
      },
      {
        id: "forms-editors",
        label: "Editors",
        link: "/forms-editors",
        parentId: "form",
      },
      {
        id: "validation",
        label: "Validation",
        link: "/validation",
        parentId: "form",
      },
      {
        id: "checkbox",
        label: "Checkbox",
        link: "/checkbox",
        parentId: "form",
      },
      {
        id: "radio",
        label: "Radio",
        link: "/forms-radio",
        parentId: "form",
      },
      {
        id: "switches",
        label: "Switches",
        link: "/switches",
        parentId: "form",
      },
    ],
  },
  {
    id: "table",
    label: "Tables",
    link: "/#",
    icon: "M4 8H20V5H4V8ZM14 19V10H10V19H14ZM16 19H20V10H16V19ZM8 19V10H4V19H8ZM3 3H21C21.5523 3 22 3.44772 22 4V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V4C2 3.44772 2.44772 3 3 3Z",
    subItems: [
      {
        id: "tables-basic",
        label: "Basic",
        link: "/tables-basic",
        parentId: "table",
      },
      {
        id: "datatables-basic",
        label: "Datatables",
        link: "/tables-datatables",
        parentId: "table",
      },
      {
        id: "tables-editable.",
        label: "Editable",
        link: "/tables-editable",
        parentId: "table",
      },
    ],
  },
  {
    label: "Users & Pages",
    isTitle: true,
  },
  {
    id: "user",
    label: "Users",
    link: "/#",
    icon: "M4 22C4 17.5817 7.58172 14 12 14C16.4183 14 20 17.5817 20 22H18C18 18.6863 15.3137 16 12 16C8.68629 16 6 18.6863 6 22H4ZM12 13C8.685 13 6 10.315 6 7C6 3.685 8.685 1 12 1C15.315 1 18 3.685 18 7C18 10.315 15.315 13 12 13ZM12 11C14.21 11 16 9.21 16 7C16 4.79 14.21 3 12 3C9.79 3 8 4.79 8 7C8 9.21 9.79 11 12 11Z",
    subItems: [
      {
        id: "profile",
        label: "Profile",
        link: "/pages-users-profile",
        parentId: "user",
      },
      {
        id: "settings",
        label: "Settings",
        link: "/pages-users-settings",
        parentId: "user",
      },
    ],
  },
  {
    id: "page",
    label: "Pages",
    link: "/#",
    icon: "M5 8V20H19V8H5ZM5 6H19V4H5V6ZM20 22H4C3.44772 22 3 21.5523 3 21V3C3 2.44772 3.44772 2 4 2H20C20.5523 2 21 2.44772 21 3V21C21 21.5523 20.5523 22 20 22ZM7 10H11V14H7V10ZM7 16H17V18H7V16ZM13 11H17V13H13V11Z",
    subItems: [
      {
        id: "blank",
        label: "Starter Page",
        link: "/blank",
        parentId: "page",
      },
      {
        id: "maintenance",
        label: "Maintenance",
        link: "/pages-maintenance",
        parentId: "page",
      },
      {
        id: "coming-soon",
        label: "Coming Soon",
        link: "/pages-coming-soon",
        parentId: "page",
      },
      {
        id: "404",
        label: "404 Error",
        link: "/pages-404",
        parentId: "page",
      },
      {
        id: "500",
        label: "500 Error",
        link: "/pages-500",
        parentId: "page",
      },
      {
        id: "503",
        label: "503 Error",
        link: "/pages-503",
        parentId: "page",
      },
    ],
  },
  {
    id: "auth",
    label: "Authentication",
    link: "/#",
    icon: "M6 10V20H19V10H6ZM18 8H20C20.5523 8 21 8.44772 21 9V21C21 21.5523 20.5523 22 20 22H4C3.44772 22 3 21.5523 3 21V9C3 8.44772 3.44772 8 4 8H6V7C6 3.68629 8.68629 1 12 1C15.3137 1 18 3.68629 18 7V8ZM16 8V7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7V8H16ZM7 11H9V13H7V11ZM7 14H9V16H7V14ZM7 17H9V19H7V17Z",
    subItems: [
      {
        id: "login",
        label: "Sign In",
        link: "/login",
        parentId: "auth",
      },
      {
        id: "signup",
        label: "Sign Up",
        link: "/signup",
        parentId: "auth",
      },
      {
        id: "reset-pw",
        label: "Reset Password",
        link: "/reset-pw",
        parentId: "auth",
      },
    ],
  },
];

export { sidebarData };
